import React, { useState } from 'react';
import { FaLocationDot } from "react-icons/fa6";
import { IoCall } from "react-icons/io5";
import { MdMessage } from "react-icons/md";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { submitContactForm } from '../../Api/api';

const ContactUs = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [type, setType] = useState('');
  const [message, setMessage] = useState('');

  const handleNameChange = (e) => {
    setName(e.target.value);
  };

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const handleCategoryChange = (e) => {
    setType(e.target.value);
  };

  const handleMessageChange = (e) => {
    setMessage(e.target.value);
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    console.log('Submitting form...');
    
    const formData = {
      name,
      email,
      message,
      type,  // Adjusted to match the FormData interface
    };
  
    try {
      await submitContactForm(formData, 
        () => {  // Success callback
          toast.success('Form submitted successfully');
          setName('');
          setEmail('');
          setMessage('');
        }, 
        () => {  // Error callback
          toast.error('Failed to submit form. Please try again later.');
        }
      );
    } catch (error) {
      console.error('Failed to submit form.', error);
      toast.error('Failed to submit form. Please try again later.');
    }
  };

  return (
    <>
    <div className='absolute top-0 left-0 w-full h-96 bg-[#8faef3]'>
      <h1 className='absolute text-white text-4xl flex justify-center items-start mt-28 w-full h-full'>Get In Touch</h1>
    </div>
    <div className="relative z-10 max-w-4xl mb-20 mx-auto flex mt-44 bg-white rounded-2xl overflow-hidden border-gray-700 shadow-lg">
    <div className="hidden md:block  p-4 m-2 rounded-xl text-white bg-[#fcb3fc]">
  <h2 className="text-xl mt-4 mb-4 items-center justify-center flex">Donate Great</h2>
  <div className="flex items-center mt-24 mb-2">
    <FaLocationDot />
    <span className="ml-4">Gurugram, Haryana, India</span>
  </div>
  <div className="flex items-center mt-4 mb-2">
    <IoCall />
    <span className="ml-4">+1234567890</span>
  </div>
  <div className="flex items-center mt-4">
    <MdMessage />
    <span className="ml-4">info@donategreat.com</span>
  </div>
</div>

      <div className='p-4'>
        <div>
          <form onSubmit={handleSubmit} className="md:p-6 sm:pt-4 sm:ml-1  space-y-4 md:ml-12">
            <div className='flex'>
              <div className='pr-2'>
                <label htmlFor="name" className="block text-sm font-medium text-gray-700">Name</label>
                <input
                  type="text"
                  id="name"
                  className="input-field border-gray-300 border-b-2 "
                  value={name}
                  onChange={handleNameChange}
                  required
                />
              </div>
              <div className='pl-2'>
                <label htmlFor="email" className="block text-sm font-medium text-gray-700">Email</label>
                <input
                  type="email"
                  id="email"
                  className="input-field border-gray-300 border-b-2 "
                  value={email}
                  onChange={handleEmailChange}
                  required
                />
              </div>
            </div>
            <div>
              <label htmlFor="type" className="block text-sm font-medium text-gray-700">Who are you ?</label>
              <select
                id="type"
                className="input-field border-none mt-2 "
                value={type}
                onChange={handleCategoryChange}
                required
              >
                <option value="">Select category</option>
                <option value="charity">Charity</option>
                <option value="ngo">NGO</option>
                <option value="donor">Donor</option>
                <option value="individual">Individual Raiser</option>
              </select>
            </div>
            <div>
              <label htmlFor="message" className="block text-sm font-medium text-[#8faef3]">Message</label>
              <textarea
                id="message"
                className="input-field border-gray-300 border-b-2 w-96 h-28"
                value={message}
                onChange={handleMessageChange}
                placeholder='write here you message...'
                required
              ></textarea>
            </div>
            <button type="submit" className="btn bg-bg-btn-1 text-white px-4 py-2 rounded-md hover:bg-blue-600 transition-colors duration-300">Submit</button>
            <ToastContainer className="mt-20" />
          </form>
        </div>
      </div>
    </div>
  </>
  );
};

export default ContactUs;
